import { Container } from "react-bootstrap";
import TransportForm from "../../../components/forms/transportForm/index";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import { publishImage } from "../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { useLazyGetShopCategoriesQuery, useCreateShopMutation } from "../../../features/shop/shopApiSlice";
const Usedvehicleshop = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
  const [shopCategory, setShopCategory] = useState();
  const [isloading, setIsloading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });
  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);

  const [createShop, setCreateShop] = useState({
    userid: name._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    marketPlace: "",
    shopCategory: "",
    businessType: "usedVehicleShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setCreateShop((createShop) => ({
      ...createShop,
      shopCategory: categoryid
    }
    ))
  }, [categoryid]);


  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const [createShopMutation] = useCreateShopMutation();

  useEffect(() => {
    getShopCategories({ type: 'usedVehicleShop', parentCategory: '' }).unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategory(response?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("usedCategories", error);
      });
  }, []);

  const PostShopData = async (e) => {
    setIsloading(true);
    e.preventDefault();
    try {
      const response = await createShopMutation(createShop).unwrap();
      if (response?.success) {
        setIsloading(false);
        setTimeout(() => {
          SuccessNotify("Form used-vehicle Created Successfully");
          navigate(`/used-vehicle-businessprofile/${response?.data?._id}`);
        }, 1000);
      }
    } catch (error) {
      setIsloading(false);
      FailedNotify("Failed To Create Shop");
    }
  };
  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }
  return (
    <Container>
      <TransportForm
        title="Fill to Create Shop Profile"
        inputtitle="Shop Name"
        butn="Create"
        backurl="/usedvehicle-integrate"
        createShop={createShop}
        setCreateShop={setCreateShop}
        PostShopData={PostShopData}
        shopCategory={shopCategory}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        Shopdatas={Shopdatas}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </Container>
  );
};
export default Usedvehicleshop;
